import { create } from 'zustand';

export type SpinAllButtonState = {
  label: string;
  disabled: boolean;
  onClick: () => void;
};

type SpinAllState = SpinAllButtonState & {
  setSpinAllButton: (button: SpinAllButtonState) => void;
  resetSpinAllButton: () => void;
};

const INITIAL_BUTTON_STATE: SpinAllButtonState = {
  label: '',
  disabled: true,
  onClick: () => undefined,
};

export const useSpinAllStore = create<SpinAllState>((set) => ({
  ...INITIAL_BUTTON_STATE,
  setSpinAllButton: (button) => set(button),
  resetSpinAllButton: () => set(INITIAL_BUTTON_STATE),
}));
